'use strict';

import 'fslightbox';

export function fslightboxInit() {
  const lightboxElements = document.querySelectorAll('.powieksz');

  lightboxElements.forEach((element, index) => {
    const gallery = element.closest('[data-gallery-group]');
    element.setAttribute('data-fslightbox', gallery ? gallery.dataset.galleryGroup : 'custom-gallery');
  });

  refreshFsLightbox();
}
